import React from 'react';
import styled from 'styled-components';

interface NoImageryModalProps {
    icon: string;
    title: string;
    text?: string;
    mobileText?: string;
}

const NoImageryModal = (props: NoImageryModalProps) => {
    const { icon, title, text, mobileText } = props;
    return (
        <React.Fragment>
            <NoImageryContainer>
                <NoImageryImage src={icon} />
                <StyledTitle>
                    <h3>{title}</h3>
                </StyledTitle>
                {text ? <StyledText>{text}</StyledText> : null}
                {mobileText ? <StyledMobileText>{mobileText}</StyledMobileText> : null}
            </NoImageryContainer>
        </React.Fragment>
    );
};

export default NoImageryModal;
const NoImageryContainer = styled.div`
    text-align: center;
    height: 60vh;
    width: 100%;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: -10px 0px -90px 0px;
    overflow-y: hidden;
`;

const NoImageryImage = styled.img`
    width: 130px;
    height: 130px;
`;

const StyledTitle = styled.div`
    max-width: 400px;
    color: #fff;

    h3 {
        color: #fff;
        margin-top: 10px;
    }
`;

const StyledText = styled.p`
    color: #fff;
    margin-top: 10px;
    max-width: 400px;
    font-size: 12px;

    @media only screen and (max-width: 600px) {
        display: none;
    }
`;

const StyledMobileText = styled.div`
    color: #fff;
    margin-top: 10px;
    display: none;

    @media only screen and (max-width: 600px) {
        display: inline-block;
        font-size: 12px;
    }
`;
